module.exports = __webpack_public_path__ + "assets/img/5_1141_big.5b682b9d.jpg";